import { memo } from 'react'
import { ProjectTaskTable } from './components/projectTaskTable/projectTaskTable'

export const ProjectDetailTaskListDataGrid = memo(() => {
  return (
    <div className="pt-2.5">
      <ProjectTaskTable />
    </div>
  )
})
